import { InputField, LabelField, MyCheckbox } from 'components';
import Selection from 'components/Selection/Selection';
import { TextareaField } from 'components/TextareaField';
import React from 'react';
import { AddNewBtn, ContactWrapper } from '../Theme';


const AddNewReportFields = ({
  formik,
  eventTypes,
  eventTypesLoading,
  openAddGroup,
  groupsList,
  groupLoading,
  frequencyList,
  frequencyLoading
}) => {
  return (
    <div className="add-new-report-fields">
      <div className="">
        <LabelField
          title={"Event Type"}
          style={{
            fontSize: "12px",
          }}
          mandatory={true}
        />
        <Selection
          name="eventType"
          mandatory={true}
          placeholder="Select Event Type"
          options={eventTypes}
          isLoading={eventTypesLoading}
          style={"secondary"}
          onChange={(value) => {
            formik.setFieldValue("eventType", value);
          }}
          value={formik.values?.eventType}
          isClearable={false}
        />
      </div>
      <div className="mt-5">
        <div className="d-flex align-items-center justify-content-between">
          <LabelField
            title={"Group"}
            style={{
              fontSize: "12px",
            }}
            mandatory={true}
          />
          <AddNewBtn onClick={() => {
            openAddGroup();
          }} className='mb-1' >
            +
            <span>New Group</span>
          </AddNewBtn>
        </div>
        <Selection
          name="group"
          mandatory={true}
          placeholder="Select Group"
          options={groupsList}
          isLoading={groupLoading}
          style={"secondary"}
          onChange={(value) => {
            formik.setFieldValue("group", value);
          }}
          value={formik.values?.group}
          isClearable={false}
        />
      </div>
      <div className="mt-5">
        <LabelField
          title={"Frequency"}
          style={{
            fontSize: "12px",
          }}
          mandatory={true}
        />
        <Selection
          name="frequency"
          mandatory={true}
          placeholder="Select Frequency"
          options={frequencyList}
          isLoading={frequencyLoading}
          style={"secondary"}
          onChange={(value) => {
            formik.setFieldValue("frequency", value);
          }}
          value={formik.values?.frequency}
          isClearable={false}
        />
      </div>
      <div className="mt-5">
        <InputField
          {...{
            formik,
            title: "Subject",
            name: "subject",
            checkValidation: true,
            value: formik.values?.subject,
            titleStyle: {
              fontSize: "12px",
            },
            mandatory: true,
          }}
        />
      </div>
      <div className="mt-5">
        <InputField
          {...{
            formik,
            title: "From",
            name: "from",
            checkValidation: true,
            value: formik.values?.from,
            titleStyle: {
              fontSize: "12px",
            },
            mandatory: true,
          }}
        />
      </div>
      <div className='mt-5'>
        <TextareaField
          rows="5"
          cols="35"
          mandatory={true}
          titleStyle={{
            fontSize: "12px",
          }}
          {...{
            formik,
            title: `Text`,
            name: `message`,
            placeholder: "Enter Text",
          }}
          onChange={(event) => {
            const value = event.target.value.replace(/\\r\\n/g, "\n").replace(/\\n/g, "\n");
            formik.setFieldValue("message", value);
          }}
        />
      </div>
      <div className='mt-5 d-flex align-items-center' style={{ gap: "20px" }}>
        <MyCheckbox
          title="Coming Soon"
          name="comingSoon"
          handlechange={(e) => {
            formik.setFieldValue(
              "comingSoon",
              e.target.checked
            );
          }}
          checked={formik.values?.comingSoon}
        />
        <MyCheckbox
          title="FollowUp"
          name="followUp"
          handlechange={(e) => {
            formik.setFieldValue(
              "followUp",
              e.target.checked
            );
          }}
          checked={formik.values?.followUp}
        />
      </div>
    </div>
  )
}

export default AddNewReportFields